import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AddDriverService {

  constructor(private http:HttpClient ) { }

  addDriver(data:any){
    return this.http.post(environment.apiUrl+"driver/registration" , data);
  }

  getAllvehicles(data:any){
    return this.http.post(environment.apiUrl+"vehicles/get/all" , data);
  }

  addImage(file ){
    const formData = new FormData(); 
    formData.append("files", file);
    return this.http.post( environment.filePath, formData )
  }
}
